import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=bcefa910&"
import script from "./DeleteButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=bcefa910&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports